import { useEffect, useState, useReducer } from 'react';  
import { Button, Card, Col, Divider, Row, Steps, Typography } from 'antd';  
import { ConfigureAddon } from './ConfigureAddon';  
  
export const ConfigAddonsSetting = ({props}) => {  
  const { Title, Paragraph } = Typography;
  const {state, dispatch} = props;

  const updateAddon = (addon) => {
    const index = addon.id;
    dispatch({type: 'UPDATE', payload: {index, addon}})
  }
  
  return (  
    <div>
      <Title level={2} >Configure selected add-ons settings</Title>
      <Paragraph>Configure the add-ons for your AIOps by selecting settings.</Paragraph>
      {
        state.map(addon => (
          <Card>
            <ConfigureAddon key={addon.id} addon={addon} updateAddon={updateAddon}/>
          </Card>
        ))
      }
    </div>
  );  
};  